<body>
    <div class="w-100 vertical-center ">
            <div class="w-70 mx-auto">
                <div class="row">
                <div class="col-4 vertical-center">
                    <img class ="constructionImage" src="\..\..\..\assets\img\consturction.webp"  >
                </div>

                

                <div class="col-8 vertical-center ">
                    <div class="mt-2 col-12 mx-auto">
                    <h1 class="responsive-font">
                        Deze pagina is nog onder constructie

                    </h1>
                    <p class="small-text">Kom later nog eens terug.</p>
                    <button [routerLink]="['',previousRoute,'tools']"
                        class="btn  btn-success mt-1">HOMEPAGINA</button>
                    </div>
                    </div>
            </div>
            </div>
    </div>
</body>